import { useState } from 'react';
import { Drawer, Flex, Layout, theme } from 'antd';
import { Link, useLocation, useNavigate } from '@tanstack/react-router';

/*import SubscriptionCheckBanner from '../components/SubscriptionCheckBanner';*/
import { COLORS } from '../utils/colors';
import useShopAttrs from '../utils/hooks/useShopAttrs';
import AnnouncementModal from '../components/AnnouncementsModal';

import {
  ArrowDataTransferHorizontalFreeIcons,
  Chart03Icon,
  CustomerService01FreeIcons,
  HelpCircleFreeIcons,
  Megaphone03FreeIcons,
  PrinterIcon,
  UserMultiple02FreeIcons,
  Settings02FreeIcons,
  SmartPhone01FreeIcons,
  Menu01Icon,
  Settings01FreeIcons,
  Invoice02FreeIcons, Store01FreeIcons, UserGroup02FreeIcons, SourceCodeIcon
} from '@hugeicons/core-free-icons';
import NavButton from '../components/NavButton';
import { NActionIcon } from '@next-is-free-monorepo/nif-web-components';
import { HugeiconsIcon } from '@hugeicons/react';
import SingleCollapse from '../components/SingleCollapse';
import PendingNotificationAlert from '../components/notifications/PendingNotificationAlert';
import { ImpersonationBanner } from '../src/components/ImpersonationBanner';

const { Content, Sider } = Layout;

const AuthLayout = ({ children }: any) => {

  const [collapsed, setCollapsed] = useState(false);

  const shopAttrs = useShopAttrs();

  const labels = {
    starter: 'Starter',
    essential: 'Basic',
    advanced: 'Pro',
    enterprise: 'Enterprise'
  };

  const {
    token: { colorBgContainer }
  } = theme.useToken();

  const navigate = useNavigate();
  const location = useLocation();


  const menuItems = [{
    icon: Chart03Icon, path: '/analytics', label: 'Analitiche', onClick: () => {
      navigate({ to: '/analytics' });
    }
  }, {
    icon: ArrowDataTransferHorizontalFreeIcons, path: '/transactions', label: 'Transazioni', onClick: () => {
      navigate({ to: '/transactions' });
    }
  }, {
    icon: Megaphone03FreeIcons,
    path: '/notifications',
    label: 'Notifiche',
    onClick: () => {
      navigate({ to: '/notifications' });
    }
  },
    {
      icon: UserMultiple02FreeIcons,
      path: '/customers',
      label: 'Clienti',
      onClick: () => {
        navigate({ to: '/customers' });
      }
    },
    {
      icon: SmartPhone01FreeIcons,
      path: '/customize',
      label: 'Personalizza',
      onClick: () => {
        navigate({ to: '/customize' });
      }

    }, {
      icon: PrinterIcon, path: '/resources', label: 'Risorse', onClick: () => {
        navigate({ to: '/resources' });
      }
    },
    {
      icon: Settings02FreeIcons,
      path: '/settings',
      label: 'Impostazioni',
      subRoutes: [
        {
          icon: Settings01FreeIcons,
          path: '/settings',
          label: 'Generali'
        },
        {
          icon: Invoice02FreeIcons,
          path: '/settings/billings',
          label: 'Abbonamento'
        },
        {
          icon: Store01FreeIcons,
          path: '/settings/sales-points',
          label: 'Punti vendita'
        },
        {
          icon: UserGroup02FreeIcons,
          path: '/settings/staff',
          label: 'Staff'
        },
        {
          icon: SourceCodeIcon,
          path: '/settings/developers',
          label: 'Sviluppatori'
        }
      ]
    }
  ];

  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <ImpersonationBanner />
      <AnnouncementModal />
      <div className={'w-full h-[40px] md:hidden'}>
        <nav style={{
          position: 'fixed',
          backgroundColor: 'white',
          top: 0,
          left: 0,
          width: '100%',
          display: 'flex',
          borderBottom: `1px solid ${COLORS.lightGray}`,
          alignItems: 'center',
          justifyContent: 'space-between',
          zIndex: 900,
          height: 55,
          padding: '8px 15px',
          fontSize: 20
        }}>
          <Flex align={'center'}>
            <img width={23} src={'/favicon.ico'} />
            <b style={{ marginLeft: 3, fontSize: 15, marginTop: 3 }}>Next is Free</b>
          </Flex>
          <NActionIcon onClick={() => setMobileDrawerOpen(true)} hugeIcon={Menu01Icon} color={'transparent'} />
        </nav>
        <Drawer open={mobileDrawerOpen} placement={'right'} onClose={() => setMobileDrawerOpen(false)}>
          {menuItems.map((item) => {

            if (item.subRoutes) {
              return (
                <SingleCollapse header={
                  <div key={item.path}
                       className={'flex items-center text-lg gap-3 cursor-pointer py-2'}>
                    <HugeiconsIcon icon={item.icon} size={20} color={'black'} />
                    <p>{item.label}</p>
                  </div>}>
                  <div className={'border-l p-2 ml-2'}>
                    {item.subRoutes.map((subItem) => (
                      <Link onClick={() => setMobileDrawerOpen(false)} to={subItem.path} key={subItem.path}
                            className={'flex items-center text-base gap-3 py-2 cursor-pointer'}>
                        <HugeiconsIcon icon={subItem.icon} size={20} color={'black'} />
                        <p>{subItem.label}</p>
                      </Link>
                    ))}
                  </div>
                </SingleCollapse>
              );
            } else {
              return (
                <Link onClick={() => setMobileDrawerOpen(false)} to={item.path} key={item.path}
                      className={'flex items-center text-lg gap-3 py-2 cursor-pointer'}>
                  <HugeiconsIcon icon={item.icon} size={20} color={'black'} />
                  <p>{item.label}</p>
                </Link>
              );
            }

          })}
        </Drawer>
      </div>
      <Layout>
        <Sider
          className={'max-md:hidden'}
          collapsedWidth={60}
          theme={'dark'}
          breakpoint={'xl'}
          onCollapse={(state) => {
            setCollapsed(state);
          }}
          width={200}
          style={{
            minHeight: 10,
            height: '100vh',
            position: 'relative'
          }}
        >
          <div style={{
            position: 'fixed',
            height: '100vh',
            minHeight: 500,
            width: collapsed ? 60 : 200,
            backgroundColor: 'white'
          }}
               className={'p-2 border-r border-slate-200'}
          >
            <div className={'flex items-center gap-2 p-2 cursor-pointer mb-5'}
                 onClick={() => navigate({ to: '/settings' })}>
              <img alt={'logo'} width={'35px'} src={'/menu-logo.svg'} />
              {!collapsed &&
                <div className={'text-xs'}>
                  <p className={'font-medium line-clamp-1 text-sm mb-0 leading-none'}>{shopAttrs.data.business_name}</p>
                  <p
                    className={'text-slate-500 leading-none text-xs capitalize'}>{shopAttrs.data.isSubscriptionValid ? 'Piano ' + labels[shopAttrs.data.subscription_plan] : 'Non abbonato'}</p>
                </div>
              }
            </div>
            {menuItems.map((item) => (
              <NavButton path={item.path} collapsed={collapsed} selected={location.pathname.includes(item.path)}
                         label={item.label} icon={item.icon}
                         key={item.path} />
            ))}
            {/*<div className={'absolute bottom-4'}>
              <NavButton label={'Aiuto'} selected={false} collapsed={collapsed} icon={CustomerService01FreeIcons}
                         path={'/aiuto'}
                         onClick={() => window.open('https://nextisfree.io/contatta-vendite', '_blank')?.focus()} />
              <NavButton label={'Help Center'} selected={false} collapsed={collapsed} icon={HelpCircleFreeIcons}
                         path={'/help'} onClick={() => window.open('https://help.nextisfree.io', '_blank')?.focus()} />
            </div>*/}
          </div>
        </Sider>
        <Layout
          style={{ backgroundColor: 'white' }}
        >
          {/* {!shopAttrs.data.completed &&
            <div className={' w-full bg-indigo-500 p-4'}>
              <p>Completa il tuo profilo</p>
            </div>
          }*/}
          {/*    <SubscriptionCheckBanner />*/}
          <Content>
            {children}
          </Content>
        </Layout>
      </Layout>
      <PendingNotificationAlert />
    </Layout>
  );
};
export default AuthLayout;
